import { Link } from "@remix-run/react";

import { useBooking } from "~/context/BookingContext";
import { HIGH_FETCH_PRIORITY } from "~/helpers/imagePriority";
import { useLocalizedPath } from "~/helpers/navigationHelper";
import common from "~/i18n/common";
import pages from "~/i18n/pages";
import { useT } from "~/i18n/useT";

import "./Hero.scss";

const AVATARS = [
  "/img/quotes/teaching.webp",
  "/img/quotes/solving.webp",
  "/img/quotes/idea_lamp.webp",
];

export default function Hero() {
  const t = useT(pages).home.hero;
  const c = useT(common);
  const localize = useLocalizedPath();
  const booking = useBooking();

  return (
    <section className="ss-hero">
      <div
        className="ss-glow ss-glow--blue ss-hero__glow-a"
        aria-hidden="true"
      />
      <div
        className="ss-glow ss-glow--orange ss-hero__glow-b"
        aria-hidden="true"
      />

      <div className="ss-hero__inner">
        <div className="ss-hero__copy">
          <p className="ss-pill">
            <span className="ss-pill__dot" aria-hidden="true" />
            {t.badge}
          </p>

          <h1 className="ss-hero__title">
            {t.titleLine1}
            <br />
            {t.titleLine2}
            <br />
            <span className="ss-hero__coding">{t.titleCoding}</span>{" "}
            {t.titleAnd} <span className="ss-hero__ai">{t.titleAi}</span>
            <span className="ss-caret" aria-hidden="true">
              _
            </span>
          </h1>

          <p className="ss-hero__lead">{t.lead}</p>

          <div className="ss-hero__actions">
            <Link to={localize("/courses")} className="ss-btn ss-btn--primary">
              {c.cta.exploreCourses}
            </Link>
            <button
              type="button"
              className="ss-btn ss-btn--ghost"
              onClick={() => booking.open()}
            >
              {c.cta.bookConsultation}
            </button>
          </div>

          <div className="ss-hero__social">
            <div className="ss-hero__avatars" aria-hidden="true">
              {AVATARS.map((src) => (
                <img
                  key={src}
                  src={src}
                  alt=""
                  width={40}
                  height={40}
                  loading="lazy"
                  decoding="async"
                />
              ))}
            </div>
            <div>
              <div className="ss-hero__stars" aria-hidden="true">
                ★★★★★
              </div>
              <p className="ss-hero__rating">{t.rating}</p>
            </div>
          </div>
        </div>

        <div className="ss-hero__media">
          <div className="ss-hero__frame">
            <img
              src="/img/hero/hero.webp"
              alt={t.imageAlt}
              width={620}
              height={520}
              // The hero is the LCP element: load it eagerly and at high priority.
              loading="eager"
              {...HIGH_FETCH_PRIORITY}
              decoding="async"
            />
          </div>

          <div className="ss-hero__stat" aria-hidden="true">
            <div className="ss-hero__stat-value">{t.yearsValue}</div>
            <div className="ss-hero__stat-label">{t.yearsLabel}</div>
          </div>

          <div className="ss-code ss-hero__code" aria-hidden="true">
            <div className="ss-code__bar">
              <span
                className="ss-code__dot"
                style={{ background: "#FF5F57" }}
              />
              <span
                className="ss-code__dot"
                style={{ background: "#FEBC2E" }}
              />
              <span
                className="ss-code__dot"
                style={{ background: "#28C840" }}
              />
            </div>
            <div className="ss-code__body">
              <div>
                <span className="ss-code__kw">const</span>{" "}
                <span className="ss-code__var">skill</span>{" "}
                <span className="ss-code__dim">=</span>{" "}
                <span className="ss-code__str">&quot;mastered&quot;</span>;
              </div>
              <div>
                <span className="ss-code__fn">function</span>{" "}
                <span className="ss-code__var">learn</span>() {"{"}
              </div>
              <div className="ss-hero__code-indent">
                return <span className="ss-code__str">confidence</span>++;
              </div>
              <div>{"}"}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
